module.exports = __webpack_public_path__ + "static/media/logo5.2f745936.svg";